import { render, staticRenderFns } from "./ArticleDescription.vue?vue&type=template&id=53bdc1ba&scoped=true&"
import script from "./ArticleDescription.vue?vue&type=script&lang=js&"
export * from "./ArticleDescription.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDescription.vue?vue&type=style&index=0&id=53bdc1ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bdc1ba",
  null
  
)

export default component.exports